<template>
  <CCard>
    <CCardHeader>
      <strong>New Daily Task</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CSelect label="Category" :options="categories" :value.sync="category_id" @change="getTopics" />
        </CCol>
        <CCol sm="12">
          <CSelect label="Category" :options="topics" :value.sync="topic_id"/>
        </CCol>
        <CCol sm="12">
          <CInput label="No. of Games" type="number" placeholder="No. of Games" v-model="task.game_count" />
        </CCol>
        <CCol sm="12">
          <CInput label="Coins Reward" type="number" placeholder="Coins Reward" v-model="task.coins" />
        </CCol>
        <CCol sm="12">
          <CInput label="Gems Reward" type="number" placeholder="Gems Reward" v-model="task.gems" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <label>Task Duration</label>
          <VueCtkDateTimePicker label="Start Time" color="#FF2E75" v-model="task.start_time" />
        </CCol>
        <CCol sm="12">
          <VueCtkDateTimePicker label="End Time"  color="#FF2E75" v-model="task.end_time" />
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary"><CIcon name="cil-check-circle"/> Add Daily Task</CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL
export default {
  name: "DailyTaskEdit",
  data() {
    return {
      task : {},
      categories : [{ value: null, label: 'Any Category'}],
      topics: [{ value: null, label: 'Any Topic'}],
      category_id: '',
      topic_id: '',
      coins: '',
      gems: '',
      start_time: '',
      end_time: '',
      game_count: 10,
    }
  },
  created() {
    this.getTask()
    this.getCategories()
  },
  methods : {
    getTask() {
      this.$axios
          .get(`${ADMIN_URL}/daily-tasks/${this.$route.params.id}`)
          .then((response) => {
            this.task = response.data
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    getCategories() {
      this.categories = [{ value: null, label: 'Any Category'}]
      this.$axios
          .get(`${ADMIN_URL}/categories`)
          .then((response) => {
            response.data.category_list.forEach((e) => {
              this.categories.push({
                value: e.id,
                label: e.name,
              });
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    getTopics() {
      this.topics = [{ value: null, label: 'Any Topic'}]
      this.$axios
          .get(`${ADMIN_URL}/topics`,{
            params: {
              category_id : this.category_id
            }
          })
          .then((response) => {
            response.data.topic_list.forEach((e) => {
              this.topics.push({
                value: e.id,
                label: e.name,
              });
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          'Accept' : 'application/json',
        }
      };

      let data = {}
      data.category_id = this.task.category_id
      data.topic_id = this.task.topic_id
      data.game_count = this.task.game_count
      data.gems = this.task.gems
      data.coins = this.task.coins
      data.start_time = this.task.start_time
      data.end_time = this.task.end_time
      data._method = 'patch'


      this.$axios.post(`${ADMIN_URL}/daily-tasks/${this.$route.params.id}`,data)
          .then(response => {
            console.log('Success', response);
            currentObj.success = response.data.success;
            console.log(response.data);
            this.$swal('Success',response.data.message,'success');
          })
          .catch(error => {
            console.log('Error  ... ', error.response);
            currentObj.output = error;
            this.$swal('Error',error.response.message,'error');
          });
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
